import type { FaireProductEntity } from "../../entity_types/product";

export const p_aumvsh43nf: FaireProductEntity = {
  token: "p_aumvsh43nf",
  type: "product",
  name: "Baby Mitten - Black",
  brandToken: "b_ee3ulfd69w",
  brandName: "Funky Junque",
  imageUrl:
    "https://cdn.faire.com/fastly/6824895d4643f08b1075d754c222da1bbfcb705dcf7bfbe8304c60f7921b47d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b2fd2ad2df5bf0711363795a17a0b67cde18962c3531f8a522137ddeffc0b003.jpeg",
  ],
  priceDollars: 7.25,
  description:
    "GREAT QUALITY: Beautifully and softly knitted 100% acrylic with a plush sherpa lining. The mitten cuffs feature a ribbed design. Wash on a cold, delicate cycle and hang to dry. Great fit and extremely durable, for both little boys and little girls alike.\nGREAT FIT: These mittens are recommended for infants between 0-9 months and measure 4.5” x 2.5” laying flat, giving the baby's hands and fingers plenty of space to move flexibly inside the gloves without making them feel too tight or loose. Easy to put on and take off, these accessories are suitable for both baby boys and baby girls alike.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:25.981Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
